import { ContextualInfoButton } from "@/components/buttons/ContextualInfoButton";
import { termsConfig } from "@/types/adaptation";
import { formatAbbreviatedValue } from "@/utils/number";
import React from "react";
import { StatsProps } from "./Stats";
type CompareValue = {
  label: string;
  value?: number;
  render?: () => React.ReactNode | string;
  color?: string;
  tag?: React.ReactNode;
};
export type CompareStatsProps = Omit<StatsProps, "value" | "icon" | "label"> & {
  label: string | React.ReactNode;
  values: CompareValue[];
  deltaLabel?: string;
};
export const CompareStats = ({
  label,
  values,
  footer,
  unit,
  unitPosition = "end",
  tag,
  contextId,
  notApplicable = false
}: CompareStatsProps) => {
  const renderUnit = (position: "start" | "end") => unit && unitPosition === position ? <span className="mr-0.5 text-xs">{unit}</span> : null;
  const renderFormattedValue = (v: number) => {
    const formatted = formatAbbreviatedValue(v, unit);
    // Sign has to lead the unit span, otherwise a leading unit renders as "$-2,000.00"
    const isNegative = typeof formatted === "string" && formatted.startsWith("-");
    return <>
        {isNegative && "-"}
        {renderUnit("start")}
        {isNegative ? formatted.slice(1) : formatted}
        {renderUnit("end")}
      </>;
  };
  return <div className="flex h-full flex-col justify-between gap-1 rounded-2xl border border-gray-200 bg-surface p-3 shadow-sm @3xl:p-4" data-sentry-component="CompareStats" data-sentry-source-file="CompareStats.tsx">
      <div className="flex items-start justify-between">
        <div className="flex-1 text-sm font-medium tracking-[-0.01em] text-gray-900">
          {label}
          {contextId && <ContextualInfoButton rootClassName="!inline-flex !ml-1" id={contextId} />}
        </div>
        {tag && <div>{tag}</div>}
      </div>
      <div className="mt-1 flex flex-col gap-1">
        {values.map(v => <div key={v.label} className="flex items-baseline justify-between gap-x-1 gap-y-[2px]">
            <span style={{
          color: v?.color ? v.color : "inherit"
        }} className="shrink-0 text-xs text-gray-500">
              {v.label}
            </span>
            {notApplicable ? <span className="text-sm font-semibold text-gray-400">N/A</span> : v?.render ? <div className={`flex justify-end text-xs font-semibold italic`} style={{
          color: v?.color ?? termsConfig.absoluteChange.color
        }}>
                {v.render()}
              </div> : <>
                <span style={{
            color: v?.color ? v.color : "inherit"
          }} className={`text-sm font-semibold tracking-[-0.015em] text-gray-900`}>
                  {v?.value != null && renderFormattedValue(v.value)}
                </span>
              </>}
          </div>)}
      </div>
      {footer && <div className="mt-1 text-xs font-medium text-gray-400">{footer}</div>}
    </div>;
};